import { FieldValues, useForm, UseFormReturn } from 'react-hook-form';
import { HookedForm } from '../HookedForm';
import { ListInterface, TagInterface } from '@app/models/util';
import { CheckSelectField } from '../Fields/CheckSelectField';
import UserProfileIcon from '@app/assets/icons/user-profile-02.svg?react';
import IconLeftIcon from '@app/assets/icons/iconleft.svg?react';
import MailBoxIcon from '@app/assets/icons/mail-box.svg?react';
import PhoneBigIcon from '@app/assets/icons/phone-big.svg?react';

export const ContactFilters = ({
  filterForm,
  lists = [],
  tags = [],
}: {
  filterForm?: UseFormReturn<FieldValues>;
  lists?: ListInterface[];
  tags?: TagInterface[];
}) => {
  const formHook = useForm();
  return (
    <div>
      <HookedForm
        formHook={filterForm ?? formHook}
        mode="onChange"
        className="flex gap-4 flex-col md:flex-row"
      >
        <CheckSelectField
          name="source"
          options={[
            {
              label: 'Manually',
              value: 'local',
              icon: <UserProfileIcon width="100%" height="100%" />,
            },
            {
              label: 'File Import',
              value: 'file-import',
              icon: <IconLeftIcon width="100%" height="100%" />,
            },
          ]}
          placeholder="All Sources"
          sizeStyle="sm"
        />

        <CheckSelectField
          name="channelType"
          options={[
            {
              label: 'Email',
              value: 'email',
              icon: <MailBoxIcon width="100%" height="100%" />,
            },
            {
              label: 'Phone',
              value: 'phone',
              icon: <PhoneBigIcon width="100%" height="100%" />,
            },
          ]}
          placeholder="All Channels"
          sizeStyle="sm"
        />
        <CheckSelectField
          name="lists"
          options={[
            ...lists.map((list) => ({ label: list.name, value: list.id })),
          ]}
          placeholder="All Lists"
          sizeStyle="sm"
        />
        <CheckSelectField
          name="tags"
          options={[...tags.map((tag) => ({ label: tag.name, value: tag.id }))]}
          placeholder="All Tags"
          sizeStyle="sm"
        />
      </HookedForm>
    </div>
  );
};
